// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { compactHeaderStyles } from "@pace/Overrides/Pages/CompactHeader";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, layoutContainer } from "@pace/XDL/Utilities";
import { css } from "styled-components";

compactHeaderStyles.page = {
    fullWidth: [true, true, true, true, true],
    css: css`
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        opacity: 0;
        transform: translateY(-100%) translateX(0);
        z-index: ${getProp("theme.zIndex.compactHeader")};
    `,
};

compactHeaderStyles.container = {
    css: css`
        background-color: ${color("common.ui1")};
        padding: 18px 0 8px 0;
        box-shadow: 0 1px ${color("common.ui11")};

        ${({ isCheckoutPage }: any) => isCheckoutPage && `padding-top: 8px;`}
    `,
};

compactHeaderStyles.bottomHeader = {
    css: css`
        display: flex;
        justify-content: space-between;
        column-gap: 47px;
        margin-top: 8px;
        ${layoutContainer};
    `,
};

compactHeaderStyles.spotSection = {
    css: css`
        display: flex;
        align-items: center;
        margin-left: auto;

        ${TypographyStyle} {
            font-size: 12px;
            line-height: 13px;
            font-weight: ${fontConfig.weight.regular};
            margin: 0;
            white-space: nowrap;
        }
    `,
};
